import * as React from 'react'
import { Icon, IconProps } from '@phosphor-icons/react'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import * as SideMenu from 'components/side-menu'
import { store } from 'store/index'
import { observer } from 'mobx-react-lite'

// Custom health audit icon (heart + ECG line) — phosphor-compatible forwardRef
export const HealthAuditNavIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ className, color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M1.75 7H3.9375L4.8125 5.6875L6.5625 8.3125L7.4375 7H8.75"
        stroke={color}
        strokeWidth="0.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5387 4.82391C1.58544 4.18614 1.84574 3.58273 2.27758 3.11108C2.70942 2.63943 3.28759 2.32707 3.91877 2.2244C4.54996 2.12173 5.19732 2.23476 5.75638 2.54524C6.31543 2.85571 6.75355 3.34552 7.00001 3.93559L7 3.9356C7.25331 3.3291 7.70885 2.82905 8.28918 2.52047C8.8695 2.21189 9.53879 2.11382 10.1833 2.24293C10.8277 2.37205 11.4076 2.72039 11.8242 3.22872C12.2409 3.73704 12.4686 4.37399 12.4688 5.03126C12.4688 8.75001 7 11.8125 7 11.8125C7 11.8125 5.15742 10.7807 3.61133 9.18757"
        stroke={color}
        strokeWidth="0.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
) as Icon

HealthAuditNavIcon.displayName = 'HealthAuditNavIcon'

export const HealthAuditLink = observer(() => {
  const path = '/health-audit'
  const title = 'Health Audit'

  const isActive = useIsActive(path)

  const enableHealthAudit = store.currentUser?.org?.enableHealthAudit
  const isAdmin = store.currentUser?.isAdmin

  if (!enableHealthAudit || !isAdmin) return null

  return (
    <SideMenu.LinkItem
      active={isActive}
      analyticsProps={sideNavAnalyticsProps({ href: path, title })}
      href={path}
      icon={HealthAuditNavIcon}
    >
      {title}
    </SideMenu.LinkItem>
  )
})
